export default "__VITE_ASSET__DgHL2pgp__"